import { IAssessmentType } from '@sondermind/utilities/models-assessments';
import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';

export const LIST_AVAILABLE_ASSESSMENT_TYPES_RESPONSE: IAssessmentType[] = [
  {
    _id: '60a1b2c3d4e5f6g7h8i9j0k1',
    name: 'AUDIT-C (Alcohol Use Disorders Identification Test-Concise)',
    description: 'A brief alcohol screening tool',
    assessmentType: ClinicalAssessmentTypes.AUDIT_C
  },
  {
    _id: '60a1b2c3d4e5f6g7h8i9j0k2',
    name: 'S2BI (Screening to Brief Intervention)',
    description: 'A validated screening tool to identify substance use risk in adolescents',
    assessmentType: ClinicalAssessmentTypes.S2BI
  }
];
